"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
exports.Pager = function (props) {
    var pagesToShow = props.pagesToShow, numberOfPages = props.numberOfPages, onPageChange = props.onPageChange, currentPage = props.currentPage, ulProps = __rest(props, ["pagesToShow", "numberOfPages", "onPageChange", "currentPage"]);
    var pagerElements = pagesToShow !== undefined ? pagesToShow : 12;
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays(["c-pager"], utilityClasses);
    // Helper function for adding page components with appropriate classes.
    var addPage = function (page, content) {
        if (content === void 0) { content = ""; }
        var pageClasses = ["c-pager__item"];
        if (page == 1) {
            pageClasses.push("+first");
        }
        if (page == currentPage) {
            pageClasses.push("+selected");
        }
        if (page == numberOfPages) {
            pageClasses.push("+last");
        }
        if (page == currentPage - 1) {
            pageClasses.push("+prev");
        }
        if (page == currentPage + 1) {
            pageClasses.push("+next");
        }
        return (react_1.default.createElement("li", { key: content + page, className: pageClasses.join(" "), onClick: function () {
                if (onPageChange) {
                    onPageChange(page);
                }
            } }, content ? content : page));
    };
    // This is the simplest strategy for creating the page list while keeping to these
    // constraints:
    // 1. The current page should be 'centered' in the list of pages, but anchored
    //    within the overall range
    // 2. The 'pagesToShow' property is actually the number of pager elements to show.
    //    That includes elipsis and next/back buttons
    // 3. Add an elipsis and the first page if the first page would not be shown based
    //    upon 1. and 2.
    // 4. Add an elipsis and the last page if the last page would not be shown based
    //    upon 1. and 2.
    //
    // The strategy is to start with the current page and add it to an array of pager
    // elements. We then try alternately to add a page before this one, and then after
    // this one. Obviously we don't do this if the target page would be out of bounds
    // in which case we continue to add pages only on the other side of the current
    // page.
    //
    // Afterwards we look at the requirement for elipsis and replace some of the elements
    // in our array with the elipsis elements.
    var pages = [addPage(currentPage)];
    // If were aren't on page 1 - we need to make room for a 'previous' button
    if (currentPage > 1) {
        pagerElements--;
    }
    // If were aren't on the last page - we need to make room for a 'next' button
    if (currentPage < numberOfPages) {
        pagerElements--;
    }
    /**
     * @var beforeOrAfter Tracks if we are considering before the current page or after
     */
    var beforeOrAfter = false;
    var minPage = currentPage;
    var maxPage = currentPage;
    var added = 0;
    // Continue until we have our desired number of pager elements or we've been unable to
    // add elements for two iterations (e.g. both before and after options are exhausted)
    while (pages.length < pagerElements && added < 2) {
        added++;
        if (!beforeOrAfter && minPage > 1) {
            minPage--;
            pages.splice(0, 0, addPage(minPage));
            added = 0;
        }
        else if (maxPage < numberOfPages) {
            maxPage++;
            pages.push(addPage(maxPage));
            added = 0;
        }
        beforeOrAfter = !beforeOrAfter;
    }
    // Add the left side elipsis
    if (minPage !== 1) {
        pages[1] = react_1.default.createElement("li", { className: "c-pager__spacer" }, "\u2026");
        pages[0] = addPage(1);
    }
    // Add the right side elipsis
    if (maxPage !== numberOfPages) {
        pages[pagerElements - 2] = react_1.default.createElement("li", { className: "c-pager__spacer" }, "\u2026");
        pages[pagerElements - 1] = addPage(numberOfPages);
    }
    // Add the left side 'previous' button
    if (currentPage > 1) {
        pages.splice(0, 0, addPage(currentPage - 1, "«"));
    }
    // Add the right side 'next' button
    if (currentPage < numberOfPages) {
        pages.push(addPage(currentPage + 1, "»"));
    }
    return (react_1.default.createElement("ul", __assign({ className: classes.join(" ") }, ulProps), pages));
};
//# sourceMappingURL=Pager.js.map